import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import CustomizedTable from '../../components/table/Table';

const styles = (theme) => ({
    content: {
        width: '90vw',
        margin: 'auto',
        marginTop: 50
    },
    box: {
        textAlign: 'left',
        marginBottom: 50
    },
    button: {
        width: '325%'
    },
    inlineDiv: {
        marginTop: 20,
        marginBottom: 20,
    },
    subtitle: {
        display: 'inline',
        fontSize: 20,
        color: '#585858'
    },
    span: {
        color: '#595959',
        float: 'right'
    },
    bootstrapInput: {
        borderRadius: 4,
        position: 'relative',
        width: '60%',
        marginRight: '5%',
        backgroundColor: theme.palette.common.white,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    bootstrapFormLabel: {
        fontSize: 18,
    },
});

const Table = (props) => {

    const {classes, head, negative, positive, finish, reply,comment} = props;

    return (
        <div className={classes.box}>
            <div>
                <div className={classes.inlineDiv}>
                    <h3 className={classes.subtitle}>NEGATIVE</h3>
                    <span className={classes.span}>RELIABILITY ★</span>
                </div>
                <CustomizedTable head={head} data={negative} reply={reply} comment={comment} type={'negative'}/>
            </div>
            <div>
                <div className={classes.inlineDiv}>
                    <h3 className={classes.subtitle}>POSITIVE</h3>
                    <span className={classes.span}>RELIABILITY ★</span>
                </div>
                <CustomizedTable head={head} data={positive} reply={reply} comment={comment} type={'positive'}/>
            </div>
            <div>
                <div className={classes.inlineDiv}>
                    <h3 className={classes.subtitle}>REPLIED</h3>
                    <span className={classes.span}>RELIABILITY ★</span>
                </div>
                <CustomizedTable head={head} data={finish} reply={reply} comment={comment} type={'finish'}/>
            </div>
        </div>
    );
};

export default withStyles(styles)(Table);
